import { Text } from '@backyard-ui/core';

export default function Disclaimer() {
  return (
    <Text size="sm" color="gray-500">
      <strong>Atenção!</strong> O prazo e valores de frete{' '}
      <strong>podem variar</strong> conforme a quantidade e disponibilidade dos
      itens adicionados ao seu carrinho. Os tempos de entrega e retirada se{' '}
      <strong>iniciam após a confirmação do seu pagamento</strong>.
    </Text>
  );
}
